import { render } from "./Basic.vue?vue&type=template&id=779d0c99&scoped=true&ts=true"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"

import "./Basic.vue?vue&type=style&index=0&id=779d0c99&scoped=true&lang=css"
import "./Basic.vue?vue&type=style&index=1&id=779d0c99&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779d0c99"]])

export default __exports__